import { inject } from '@angular/core';
import { AnyAbility } from '@casl/ability';
import { AbilityService } from '@casl/angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type CanObservableFn = (
  ...args: Parameters<AnyAbility['can']>
) => Observable<boolean>;

/**
 * Returns a function that checks a permission as an Observable. It emits the
 * current result on subscribe and again whenever the user's permissions change.
 * Must be called in an injection context (e.g. a field initializer); the returned
 * function can be called anywhere.
 *
 * Bridge for code migrated from the `AblePurePipe` removed in @casl/angular 10
 * (WILP-14032).
 *
 * @deprecated Use signals instead: `protected readonly can = inject(AbilityServiceSignal).can;`
 * and read it in a template or `computed(() => this.can(action, subject))`.
 */
export function injectCan$(): CanObservableFn {
  const abilityService = inject<AbilityService<AnyAbility>>(AbilityService);
  return (...args) =>
    abilityService.ability$.pipe(map((ability) => ability.can(...args)));
}
